import { Header, Input } from '@mairistem/composants';
import React from 'react';
import './CodeInput.css';

interface CodeInputProps {
	code: string;
	onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const CodeInput = ({ code, onChange }: CodeInputProps) => (
	<>
		<Input
			className="autorisationCodeInput"
			data-testid="codeInput"
			name="code"
			onChange={onChange}
			value={code}
		/>
		<Header
			floated="left"
			size="tiny"
			subheader="Code numérique d'identification de l'autorisation"
		/>
	</>
);

export default CodeInput;
